import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-worldlabs-large.tsx
/**
* icon.24.logo.worldlabs.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTMuMDExIDQuNTM4Yy0uMTA3LS41NjMuNjE0LS44ODcuOTYtLjQzM2w0LjgyIDcuOTMxYzEuMDYxIDEuMTk4IDEuOTkyLjgxNSAyLjgwNy40NjlsOC43MTgtMy4wODhjLjQ4My0uMTMuODUuMjgxLjYwNi43MTRsLTUuNDI3IDkuNjdjLS4xNzMuMzI0LS42NTcuNDI1LS45MS4xNThsLTMuNDctMy41NWMtLjkwMi0xLjA5LTIuMzc0LTEuMTktMy4zNy0uMThsLTEuMDk3IDEuMTFjLS4zNjguNDEyLS45NzMuMjk3LTEuMDgyLS4yNDRMMy4wMTggNC41Mzh6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26876-63909
*/
const Icon24LogoWorldlabsLarge = memo(function Icon24LogoWorldlabsLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M3.011 4.538c-.107-.563.614-.887.96-.433l4.82 7.931c1.061 1.198 1.992.815 2.807.469l8.718-3.088c.483-.13.85.281.606.714l-5.427 9.67c-.173.324-.657.425-.91.158l-3.47-3.55c-.902-1.09-2.374-1.19-3.37-.18l-1.097 1.11c-.368.412-.973.297-1.082-.244L3.018 4.538z"
		})
	});
});
//#endregion
export { Icon24LogoWorldlabsLarge };

//# sourceMappingURL=icon-24-logo-worldlabs-large.js.map